import React, { useContext, useEffect, useState } from 'react'
import Managebtn from '../../../Component/Managebtn'
import Tracker from './Tracker'
import { SpeechContext } from '../../../Providers/SpeechWrapper';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../Providers/LanguageContext';

function BudgetTracker2() {
    const [time, setTime] = useState("")
    const { language } = useLanguage();
    const navigate = useNavigate()
    const { isProject, setIsproject } = useContext(SpeechContext);
    console.log('isProjectbb', isProject)


    const getTime = (val) => {
        setTime(val)
    }

    useEffect(() => {
        window.scrollTo({ top: '0', behavior: 'instant' })
    }, [])

    useEffect(() => {
        setIsproject(true)
        // else if(isProject==true){
        //     setIsproject(false)
        // }
        // else{

        // }

    }, [])

    return (
        <>
            {/* <div className=''>
                <button className='w-25 mb-2 btn btn-outline-success' style={{ fontWeight: "bold", margin: "0 0 0 120px" }} onClick={() => navigate('/project-performance')}>
                    {language.view_pro_performance}
                </button>
            </div> */}

            {/* <div className="try_fisibilty_wrapper " style={{
                transform: 'translateY(0%)',
                margin: '0px',
                justifyContent: 'start',
                background: '#031f31ff'

            }}>
                <div className="container-fluid">
                    <p className="text-left">Project Manager / Setup project & project budget</p> </div>
            </div> */}
            <div style={{
                background: 'linear-gradient(rgb(15, 36, 55),#fff)',
                padding: '50px 0px'
            }}>
                <div className='container-fluid'>
                    <div className='task_head'>Setup project & project budget</div>
                </div>
                <div className='container-fluid mt-3'>
                    <button className='slctUser ' style={{
                        background: 'rgb(136, 233, 132)',
                        fontWeight: '500',
                        color: '#0c2637'
                    }}
                        onClick={() => navigate('/project-performance')}>
                        {language.view_pro_performance}
                    </button>
                </div>
                <div className='container-fluid' style={{
                    marginTop: '30px',
                    border: '4px solid #fff',
                    padding: '40px 20px',
                    borderRadius: '25px',
                    marginTop: '20px'
                }}>

                    <Managebtn white={true} getTime={getTime} value={time} />
                    <Tracker time={time} setTime={setTime} />
                </div>

            </div>


        </>
    )
}

export default BudgetTracker2